new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {
   
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: false,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('#slick-instagram').then(element => {
        $('#slick-instagram').slick({
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });        
    });

    waitForElementToExist('.about-themes').then(element => {
        var contents = document.querySelectorAll('.about-themes-content');
        contents.forEach(function (el) {
      
          var dataLenAttr = el.getAttribute('data-length');
          if (!dataLenAttr) return;
      
          var dataLen = parseInt(dataLenAttr.replace(/[.,]/g, ""), 10);
      
          if (dataLen <= 500) {
            return;
          }
          el.style.maxHeight = '300px';
          el.style.overflow = 'hidden';
      
          // Cria botão fora do conteúdo para evitar interferir no HTML interno
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'about-themes-toggle';
          btn.textContent = 'ver mais';
          el.insertAdjacentElement('afterend', btn);
      
          btn.addEventListener('click', function () {
            var expanded = el.getAttribute('data-expanded') === 'true';
            if (expanded) {
              el.setAttribute('data-expanded', 'false');
              el.style.maxHeight = '300px';
              el.style.overflow = 'hidden';
              btn.textContent = 'ver mais';
            } else {
              el.setAttribute('data-expanded', 'true');
              el.style.maxHeight = 'none';
              el.style.overflow = 'visible';
              btn.textContent = 'ver menos';
            }
          });
        });
    });


    waitForElementToExist('.rotation-vitrine').then(element => {
        let rotationVitrine = document.querySelector('.rotation-vitrine');
        if (rotationVitrine) {
            let rotationNames = rotationVitrine.querySelectorAll('.categories .categories__name');
            let initVitrine = rotationVitrine.querySelectorAll('.rotation-vitrine__products .item');
            initVitrine = Array.from(initVitrine);
        
            if(rotationVitrine && rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
        
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    $('#js-rotation-vitrine4, #js-rotation-vitrine3, #js-rotation-vitrine2, #js-rotation-vitrine').slick('refresh').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                        Blazy({
                            selector: '.lazy-img',
                            successClass: 'loaded-img',
                            success: function (element) {
                                setTimeout(function () {
                                    var parent = element.previousSibling;
                                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                                }, 100);
                            }
                        });
                    });
                }
        
                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                })
            }
        }

        $('#js-rotation-vitrine, #js-rotation-vitrine2, #js-rotation-vitrine3, #js-rotation-vitrine4').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
    
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        arrows: true,
                    }
                }
            ]
        })
    });

    // Função para gerenciar a ativação dos elementos
    function initBannerCategories() {
        const titles = document.querySelectorAll('.banner-categories__title h2');
        const contents = document.querySelectorAll('.banner-categories__content');
        const tools = document.querySelectorAll('.banner-categories__tools');

        // Configurações do Slick
        const slickOptions = {
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            autoplay: false,
            pauseOnHover: true,
            pauseOnFocus: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 5,
                    }
                }
            ]
        };

        // Função para ativar um elemento específico
        function activateElement(index) {
            // Remove a classe active de todos os elementos
            titles.forEach(title => title.classList.remove('active'));
            contents.forEach(content => content.classList.remove('active'));
            tools.forEach(tool => tool.classList.remove('active'));

            // Adiciona a classe active ao título e conteúdo correspondentes
            titles[index].classList.add('active');
            contents[index].classList.add('active');

            // Ativa a ferramenta correspondente baseada no ID do título
            const activeTitleId = titles[index].id;
            const toolClass = activeTitleId.replace('-title', '');
            const correspondingTool = document.querySelector(`.${toolClass}`);
            if (correspondingTool) {
                correspondingTool.classList.add('active');
            }

            // Destrói e reinicia o Slick para o conteúdo ativo
            if ($(contents[index]).hasClass('slick-initialized')) {
                $(contents[index]).slick('unslick');
            }
            $(contents[index]).slick(slickOptions);
        }

        // Inicializa o Slick para cada conteúdo primeiro
        contents.forEach((content, index) => {
            if (!$(content).hasClass('slick-initialized')) {
                $(content).slick(slickOptions);
            }
        });

        // Adiciona evento de clique em cada título
        titles.forEach((title, index) => {
            title.addEventListener('click', () => {
                activateElement(index);
            });
        });

        // Ativa o primeiro elemento por padrão
        if (titles.length > 0) {
            activateElement(0);
        }
    }

    // Aguarda o elemento existir antes de inicializar
    waitForElementToExist('.banner-categories').then(element => {
        initBannerCategories();
    });
});

function copyElementContentToClipboard(event) {
    var clipboardElement = event.currentTarget;
    var clipboardContent = clipboardElement.textContent || clipboardElement.innerText;
    
    navigator.clipboard.writeText(clipboardContent).then(function() {
        clipboardElement.classList.add("copied");
    }).catch(function(error) {
        console.error("Erro ao copiar para o clipboard:", error);
    });
}

// Adicionar o event listener ao elemento clipboard
const tcCoupon = document.getElementById("tc-coupon");
if (tcCoupon) {
    tcCoupon.addEventListener("click", copyElementContentToClipboard);
}
